/* eslint-disable no-nested-ternary */
function getByPath(
  obj,
  keyPath,
  defaultValue = undefined,
  alternativePath = undefined
) {
  return keyPath.split('.').reduce(
    (result, key) => (
      (result !== undefined && typeof result[key] !== 'undefined')
        ? result[key]
        : alternativePath ? getByPath(obj, alternativePath, defaultValue) : defaultValue
    ),
    obj
  );
}

module.exports = getByPath;
